import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'deleteCharactersFile'
})


export class DeleteCharactersFilePipe implements PipeTransform {
  transform(value: string, quantity: number, mobile: boolean): string {
    if (mobile) {
      return `${value.substring(0, quantity)}..${value.substring(value.lastIndexOf('.'), value.length)}`
    }
    return value
  }
}
